import type { FileType } from "@/types/common/files";
import axios from "@/utils/axios";
import { useMutation, useQuery } from "@tanstack/react-query";

export interface UploadFilePayload {
  file: File;
  entity_id: string;
  entity_type: string;
  collection?: string;
}

export interface UploadFileResponse {
  id: string;
  name: string;
  url: string;
  file_name: string;
  collection: string;
  size: number;
  model_id: string;
  model_type: string;
  created_by: string | null;
  updated_at: string | null;
  created_at: string | null;
}

export const uploadFile = async ({
  file,
  entity_id,
  entity_type,
  collection,
}: UploadFilePayload): Promise<{ data: UploadFileResponse }> => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("entity_id", entity_id);
  formData.append("entity_type", entity_type);
  if (collection) {
    formData.append("collection", collection);
  }
  const response = await axios.post("admin/v1/file", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
      Accept: "application/json",
    },
  });
  return response.data;
};

export const getFile = async (fileId: string): Promise<{ data: FileType }> => {
  const response = await axios.get(`/admin/v1/file/${fileId}`, {
    headers: {
      Accept: "application/json",
    },
  });
  return response.data;
};

export const useGetFile = (fileId: string, enabled = true) => {
  return useQuery({
    queryKey: ["file", fileId],
    queryFn: () => getFile(fileId),
    enabled: !!fileId && enabled,
    staleTime: 55 * 60 * 1000, // 55 minutes
  });
};

export const useDeleteFile = () => {
  return useMutation({
    mutationFn: async (fileId: string) => {
      const response = await axios.delete(`/admin/v1/file/${fileId}`, {
        headers: {
          Accept: "application/json",
        },
      });
      return response.data;
    },
  });
};
